import { createReducer, on } from '@ngrx/store'
import { ConciergeActions } from './concierge.actions'

export interface LoginConciergeResponse {
	_id: string
	email: string
	username: string
	name: string
	lastName: string
	role: string
}

export interface ConciergeState {
	conciergeUser: LoginConciergeResponse | null
	isLoggedIn: boolean
	loginStatus: 'idle' | 'pending' | 'success' | 'failure'
}

let initialConciergeUser: LoginConciergeResponse | null = null

try {
	const conciergeUserFromStorage = localStorage.getItem('CONCIERGE_USER')
	if (conciergeUserFromStorage) {
		initialConciergeUser = JSON.parse(conciergeUserFromStorage)
	}
} catch (error) {
	console.error('Erro ao fazer parse do conciergeUser do localStorage:', error)
	localStorage.removeItem('CONCIERGE_USER')
}

const initialState: ConciergeState = {
	conciergeUser: initialConciergeUser,
	isLoggedIn: !!initialConciergeUser,
	loginStatus: 'idle',
}

export const conciergeReducers = createReducer<ConciergeState>(
	initialState,

	on(
		ConciergeActions.loadConcierge,
		ConciergeActions.loginConciergeUser,
		(state): ConciergeState => ({
			...state,
			loginStatus: 'pending',
		})
	),

	on(
		ConciergeActions.loginConciergeUserSuccess,
		(state, { conciergeUser }): ConciergeState => ({
			...state,
			conciergeUser,
			isLoggedIn: true,
			loginStatus: 'success',
		})
	),

	on(
		ConciergeActions.loginConciergeUserFailure,
		(state): ConciergeState => ({
			...state,
			conciergeUser: null,
			isLoggedIn: false,
			loginStatus: 'failure',
		})
	),

	on(
		ConciergeActions.logoutConciergeUser,
		(): ConciergeState => ({
			...initialState,
			conciergeUser: null,
			isLoggedIn: false,
			loginStatus: 'idle',
		})
	)

	// on(ConciergeActions.logoutConciergeUser, (state): ConciergeState => {
	//     return {
	//         ...state,
	//         isLoggedIn: false,
	//         conciergeUser: null,
	//     }
	// }),
)
